import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import { enableDisableDrive } from './actions';
import colors from 'theme/_colors.scss';
import './style.scss';

const EnableDisableDriveComponent = ({ show, close, assetId, isDisabled, gatewayID }) => {
    const dispatch = useDispatch();
    const { t: translate } = useTranslation();

    const content = <div className='enable-disable-drive__content'>
        <div>{translate('ABB.Powertrain.Frontend.drivesDataDeactivatedTextLabel')}</div>
    </div>;

    const getRefreshGatewayTitle = <h1 className='enable-disable-drive__title'>
        <IconInfoFilled color={colors.primaryInfo} />
        <span className='enable-disable-drive__title-text'>{translate('ABB.Powertrain.Frontend.drivesDataDeactivateModalTitle')}</span>
    </h1>;

    return <GeneralDialog
        show={show}
        close={close}
        id='enable-disable-drive-dialog'
        title={getRefreshGatewayTitle}
        dialogClassName='enable-disable-drive__dialog'
        closeButton={true}
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.cancelLabel'),
        }}
        acceptButtonProps={{
            text: translate('ABB.Powertrain.Frontend.drivesDataDeactivateButtonLabel'),
            onClick: () => {
                dispatch(enableDisableDrive(assetId, isDisabled, gatewayID));
                close();
            }
        }}
    >
        {content}
    </GeneralDialog>;
};

EnableDisableDriveComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    assetId: PropTypes.number,
    isDisabled: PropTypes.bool,
    gatewayID: PropTypes.any
};

export default EnableDisableDriveComponent;
